import Routes from 'containers/Routes';
import { black, paperWhite } from 'core/styles';
import React, { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import io from 'socket.io-client';
import styled, { createGlobalStyle } from 'styled-components';
import { reset } from 'styled-reset';
import Gorey from './fonts/Gorey.ttf';

const isDev = process.env.NODE_ENV === 'development';
const isE2ETesting = process.env.REACT_APP_E2E_TESTING === 'true';
const socketUrl = isDev || isE2ETesting
  ? 'http://localhost:3001'
  : 'https://vampire-party-api-production.up.railway.app';

const socket = io(socketUrl);

const Main = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const GlobalStyle = createGlobalStyle`
    ${reset}
    @font-face {
      font-family: 'Gorey';
      src: local('Gorey'), url(${Gorey}) format('truetype');
    }
    body {
      font-family: Gorey;
      padding: 0;
      line-height: 1.1;
      letter-spacing: 1.2px;
      background-color: ${paperWhite};
      color: ${black};
      font-size: 16px;
      user-select: none;
      overflow: visible;
    },
    input, textarea, button {
      font-family: Gorey;
    }
  `;
function App() {
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    // Expose socket to window for Cypress E2E tests
    if (window.Cypress) {
      window.socket = socket;
    }
    
    socket.on('connected-to-server', function ({ status }) {
      setConnected(status === 200);
    });
    socket.on('disconnect', () => {
      setConnected(false);
    });
  }, []);

  return (
    <>
      <GlobalStyle />
      <BrowserRouter>
        <Main>
          <Routes connected={connected} socket={socket} />
        </Main>
      </BrowserRouter>
    </>
  );
}

export default App;
